// @ts-nocheck
import React, { useState, useImperativeHandle } from 'react'
import styles from './index.scss'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import DpButtonThemeConfig from '@/libs/components/DpUiComponents/DpButtonThemeConfig'
import DpCalendar from '@/libs/components/DpFunctionComponents/DpCalendar'
import dayjs from 'dayjs';
import classnames from 'classnames'
import { RightOutline } from 'antd-mobile-icons'
import { TrackView } from '@dragonpass/intl-unified-tracker'
import DpTracker from '@/libs/components/DpTrackerComponents/DpTracker'
import { Toast } from 'antd-mobile'

interface IDpPickerProps {
  title?: string
  value?: string | undefined | number | Array
  comValue?: string
  calendarProps?: any
  footerRender?: any
  onChange?: (date: string) => void
  onClose?: () => void
  buttonStyles?: React.CSSProperties
  customStyles?: React.CSSProperties
  onRef?: any
  okSummit?: any
  hiddenLabel?: boolean
  disabled?: boolean
  isTheme?: boolean
  placeholder?: string
  transformChangeValue?: (value) => void
  summitChangeValue?: (value) => void
  hasTrackerPermission?: boolean
  track_module_name?: string
}

const DpCalendarPicker: React.FC<IDpPickerProps> = (props) => {
  const [currentValue, updateCurrentValue] = useState(props?.value)
  const [visible, updateVisible] = useState(false)

  const setUpdateVisible = () => {
    if (props?.hasTrackerPermission) {
      window?.dpTracker?.sendClk({
        eventData: {
          module_name: props?.track_module_name || '切换日期'
        }
      })
    }
    if (props?.transformChangeValue) {
      updateCurrentValue(props?.transformChangeValue?.(props?.value))
    } else {
      updateCurrentValue(props?.value ? props?.value : null)
    }
    updateVisible(!visible)
  }
  //用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      setUpdateVisible,
      currentValue
    }
  })

  const renderContent = () => {
    return (
      <div
        className={classnames([styles['dp-picker-body'], {
          [styles['dp-picker-body--list']]: props?.calendarProps?.type === 'list'
        }])}
      >
        <DpCalendar
          allowClear={false}
          selectionMode="single"
          {...props?.calendarProps}
          value={currentValue}
          onChange={(e) => {
            updateCurrentValue(e)
            props?.calendarProps?.onChange?.(e && dayjs(e).format(props?.format || 'YYYY-MM-DD'))
          }}
        />
      </div>
    )
  }

  return (
    <div className={
      classnames([styles['dp-picker-calendar'], {
        [styles['dp-picker-calendar--renderLabel']]: props?.calendarProps?.renderLabel,
        [styles['dp-picker-calendar--disabled']]: props?.disabled
      }])
    }>
      {
        !props?.hiddenLabel &&
          <div
            onClick={() => setUpdateVisible()}
            className={styles['dp-picker-desc']}
          >
            <div className={styles['dp-picker-desc-body']}>
              {props?.comValue || props?.value || (
                <span className={styles['dp-picker-placeholder']}>
                  {props?.placeholder || lang['请选择日期']}
                </span>
              )}
            </div>
            {!props?.disabled && <RightOutline className={styles['dp-picker-arrows']} />}
          </div>
      }
      {visible && (
        <DpBusinessPopup
          {...props?.popupProps}
          title={props?.title || lang['选择日期']}
          visible={visible}
          closeOnMaskClick={true}
          allowHeaderClose={false}
          onClose={() => {
            updateVisible(!visible)
            props?.onClose?.()
          }}
          containerStyles={{ padding: 0, overflowY: props?.calendarProps?.type === 'list' ? 'hidden' : 'aut' }}
          headerStyle={{ borderBottomWidth: 0, background: 'var(--content-bg-color, #ffffff)' }}
          titleStyle={{...props?.customStyles }}
          popupBodyStyles={{ maxHeight: '90vh', ...props?.customStyles }}
          footer={
            <div className={styles['dp-picker-footer-body']}>
              {props?.footerRender}
              <div className={styles['dp-picker-footer']}>
                <DpButtonThemeConfig
                  btnProps={{
                    shape: "rounded",
                    ariaLabel: props?.submitText || lang['确 定']
                  }}
                  buttonText={props?.submitText || lang['确 定']}
                  isTheme={props?.isTheme}
                  onClick={async () => {
                    let isAllowSummit = true
                    if (!currentValue) {
                      Toast.show({
                        content: `请选择日期`,
                      })
                      isAllowSummit = false
                      return
                    }
                    if (props?.okSummit) {
                      isAllowSummit = await props?.okSummit?.(currentValue)
                    }
                    if (isAllowSummit) {
                      updateVisible(!visible)
                      if (Array.isArray(currentValue)) {
                        if (props?.summitChangeValue) {
                          props?.onChange?.(props?.summitChangeValue?.(currentValue && currentValue.map(item => dayjs(item).format(
                            props?.format || 'YYYY-MM-DD',
                          ))))
                        } else {
                          props?.onChange?.(currentValue && currentValue.map(item => dayjs(item).format(
                            props?.format || 'YYYY-MM-DD',
                          )))
                        }
                      } else {
                        props?.onChange?.(
                          currentValue &&
                          dayjs(currentValue).format(props?.format || 'YYYY-MM-DD'),
                        )
                      }
                    }
                  }}
                  style={props?.buttonStyles}
                />
              </div>
            </div>
          }
        >
          <DpTracker>
            <TrackView
              component="div"
              trackClk={false}
              trackData={{
                module_name: `${props?.track_module_name || '切换日期'}弹窗`,
              }}
              trackExp={props?.hasTrackerPermission}
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              {renderContent()}
            </TrackView>
          </DpTracker>
        </DpBusinessPopup>
      )}
    </div>
  )
}

export default DpCalendarPicker
